// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, type IntlShape } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import type { FormProps } from 'redux-form';

import { bindActionCreatorsForm } from 'util/safeDispatch';
import { setLocale, setMessages } from 'state/commands/intlCommands';
import type { Dispatch } from 'state/types';
import { getIsLoggedIn } from 'state/selectors';
import LocaleSwitcher from 'portfolio-shared/view/Login/LocaleSwitcher';
import localizedStrings from 'util/localizedStrings';
import { login } from 'state/commands/authCommands';
import { FC_INVALID_CREDENTIALS } from 'portfolio-shared/util/faultCode';
import { version } from 'util/constants';

import './Login.css';

type Props = {
  closeModal: () => void,
  intl: IntlShape,
  isLoggedIn: boolean,
  login: typeof login,
} & FormProps;

class LoginForm extends Component<Props> {
  renderInput: Function;
  submit: Function;
  setLocale: Function;

  constructor() {
    super();
    this.renderInput = this.renderInput.bind(this);
    this.submit = this.submit.bind(this);
    this.setLocale = this.setLocale.bind(this);
  }

  // Uncomment to automatically login for development.
  /*
  async componentDidMount() {
    if (!window.didAutologin) {
      await this.props.login('administrator', 'password');
      this.props.closeModal();
      window.didAutologin = true;
    }
  }
  */

  async submit(values, dispatch, props) {
    // TODO: submit form and close modal via reducers
    const { username, password } = values;
    await this.props.login(username, password);

    if (this.props.isLoggedIn) {
      this.props.closeModal();
    }
  }

  setLocale(locale) {
    this.props.setLocale(locale);
    this.props.setMessages(locale);
  }

  renderInput(field) {
    const { intl } = this.props;
    const { input, type = 'text' } = field;
    const { name } = input;

    const placeholder =
      name === 'username'
        ? intl.formatMessage(localizedStrings.USER_NAME)
        : intl.formatMessage(localizedStrings.PASSWORD);

    return (
      <input
        {...input}
        data-test-name={`${name}-input`}
        className="input"
        placeholder={placeholder}
        style={{ width: '100%' }}
        type={type}
      />
    );
  }

  render() {
    const { error, handleSubmit, intl, pristine } = this.props;
    return (
      <form onSubmit={handleSubmit(this.submit)} data-test-name="login-form">
        <div className="loginHeader" />

        <div className="loginForm">
          <div className="level">
            <Field name="username" component={this.renderInput} type="text" />
          </div>

          <div className="level">
            <Field
              name="password"
              component={this.renderInput}
              type="password"
            />
          </div>

          <div className="level select">
            <LocaleSwitcher
              locale={this.props.intl.locale}
              selectClassName="localePicker"
              setLocale={this.setLocale}
            />
          </div>

          <div className="level">
            <button
              type="submit"
              data-test-name="login-submit-button"
              className="button is-primary"
              disabled={pristine || error}
              style={{ width: '100%' }}
            >
              {intl.formatMessage(localizedStrings.LOGIN)}
            </button>
          </div>

          <div className="versionNumber">Portfolio {version}</div>
        </div>
      </form>
    );
  }
}

function validate(data: Object, props: Props) {
  return {
    _error: !data.username || !data.password,
  };
}

let wrappedForm = reduxForm({
  form: 'login',
  validate,
})(LoginForm);

wrappedForm = injectIntl(wrappedForm);

export default (wrappedForm = connect(
  state => ({
    isLoggedIn: getIsLoggedIn(state),
  }),
  (dispatch: Dispatch) =>
    bindActionCreatorsForm(
      {
        login,
        setLocale,
        setMessages,
      },
      { [FC_INVALID_CREDENTIALS]: localizedStrings.loginFailed }
    )
)(wrappedForm));



// WEBPACK FOOTER //
// ./src/view/App/Login/LoginForm.js